module.exports = __webpack_public_path__ + "static/media/checkbox-disable.d240a559.svg";